export default __webpack_public_path__ + "static/media/phone.749d7250.svg";